import { render, staticRenderFns } from "./FormWizardVertical.vue?vue&type=template&id=e6a713e4&"
import script from "./FormWizardVertical.vue?vue&type=script&lang=js&"
export * from "./FormWizardVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports